export const ADMIN_DASH_RETURN_QUERY_PARAM = 'from';
export const ADMIN_DASH_RETURN_MARKER = 'admin-dash';
